import React, { FC, useState } from 'react';
import classnames from 'classnames';
import { ChevronLeft, ChevronRight } from 'react-bootstrap-icons';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { IImage, IProductLabel } from 'api/types';
import { WiseLabel } from 'components/wise';

import styles from 'theme/pages/wise/WiseProduct/components/WiseGallery/WiseGallery.module.scss';

interface IProps {
  images: IImage[];
  labels: IProductLabel[];
}

export type WiseGalleryProps = IProps;

const WiseGallery: FC<IProps> = ({ images, labels }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const slidesToShow = Math.min(4, images.length);
  const slideCount = images.length;

  const goPrev = () => {
    if (slideCount <= 1) return;
    setCurrentImageIndex((i) => (i - 1 + slideCount) % slideCount);
  };

  const goNext = () => {
    if (slideCount <= 1) return;
    setCurrentImageIndex((i) => (i + 1) % slideCount);
  };

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Pages-Wise-WiseProduct-components-WiseGallery'
      )}>
      <div className={styles.mainImageWrap}>
        <div className={styles['main-image']}>
          <div className={styles.mainImageViewport}>
            <div
              className={styles.mainImageTrack}
              style={
                slideCount > 0
                  ? {
                      width: `${slideCount * 100}%`,
                      transform: `translateX(-${(currentImageIndex * 100) / slideCount}%)`
                    }
                  : undefined
              }>
              {images.map((image, index) => (
                <div
                  key={index}
                  className={styles.mainImageSlide}
                  style={{
                    width: `${100 / slideCount}%`,
                    backgroundImage: `url(${image.big})`
                  }}
                />
              ))}
            </div>
          </div>
          <div className={styles.mainImageLabels}>
            {labels.map((label) => (
              <WiseLabel key={label.type} label={label} />
            ))}
          </div>
        </div>

        {images.length > 1 && (
          <>
            <button
              type="button"
              className={classnames(styles.mainNavButton, styles.mainNavPrev)}
              onClick={goPrev}
              aria-label="Poprzednie zdjęcie">
              <ChevronLeft />
            </button>
            <button
              type="button"
              className={classnames(styles.mainNavButton, styles.mainNavNext)}
              onClick={goNext}
              aria-label="Następne zdjęcie">
              <ChevronRight />
            </button>
          </>
        )}
      </div>

      {images.length > 1 && (
        <Slider
          dots={false}
          infinite={false}
          arrows={images.length > slidesToShow}
          slidesToShow={slidesToShow}
          slidesToScroll={1}>
          {images.map((image, index) => (
            <div className={styles.thumb} key={index} onClick={() => setCurrentImageIndex(index)}>
              <div
                className={classnames(styles.image, {
                  [styles.active]: index === currentImageIndex
                })}
                style={{ backgroundImage: `url(${image.thumb})` }}
              />
            </div>
          ))}
        </Slider>
      )}
    </div>
  );
};

export default WiseGallery;
